import { render, staticRenderFns } from "./CheckedPlates.vue?vue&type=template&id=4dce6159"
import script from "./CheckedPlates.vue?vue&type=script&lang=js"
export * from "./CheckedPlates.vue?vue&type=script&lang=js"
import style0 from "./CheckedPlates.vue?vue&type=style&index=0&id=4dce6159&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports